import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { deliveryDates } from "../../../../../../redux/delivery-dates/action";
import { selectDeliveryDatesListItems } from "../../../../../../redux/delivery-dates/selector";

const ManagementDeliveryDates = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const deliveryDateItems = useSelector(selectDeliveryDatesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name' },
          { field: 'DisplayOrder', headerName: 'Display Order' }
      
        ]);
      }
      const fetchDeliveryDates=()=>{

        dispatch(deliveryDates.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/delivery-dates/list`,entity:'deliveryDates',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchDeliveryDates()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add DeliveryDates',
      callback: () => handleAdd(),
    }
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(deliveryDates.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/delivery-dates/delete`,
      entity: 'deliveryDates',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(deliveryDates.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/delivery-dates/list`,entity:'deliveryDates',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {deliveryDateItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={deliveryDateItems?.result?.items} setPageData={setPageData}
    paginationData={deliveryDateItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Delivery Dates" />
  }
  </> 
     
	);
};

export default ManagementDeliveryDates;


